const i18nConfig = {
  locales: ["tw", "cn"],
  defaultLocale: "tw",
  localeDetection: true,
};

module.exports = i18nConfig;
